import { RouterType } from '@online-webinar/router';
import { FollowUpOverviewPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/follow-up/'].update({
        staticData: { title: { page: 'FollowUpOverview.PageHeading', forWebinar: true } },
        component: authGuard(FollowUpOverviewPage, { canBroadcast: true })
    });
};
